<template>
  <div id="app">
    <noindex>
<!--    <div class="layoutBorder">-->
<!--      <div class="layoutHeader"> <h4>Технические работы</h4> </div>-->
<!--      <div class="layoutBody"> В течение некоторого времени сервис будет недоступен. </div>-->
<!--    </div>-->
      <div>
        <img v-if="cookie == '100003'" src="https://cfv4.com/v2/pixel.png?apiToken=59619c3a-9618-4325-b2ef-45f18723e59e" style="position:absolute; left:-9999px;">
        <headBar     v-if="isNotCC"></headBar>
        <frstScreen  v-if="isNotCC"></frstScreen>
        <advantages  v-if="isNotCC"></advantages>
        <fast        v-if="isNotCC"></fast>
        <formWrap></formWrap>
        <specAndDocs v-if="isNotCC"></specAndDocs>
        <contact     v-if="isNotCC"></contact>
        <footerLine  v-if="isNotCC"></footerLine>
      </div>
    </noindex>
  </div>
</template>

<script>
  var link = document.createElement('meta');
  link.setAttribute('property', 'robots');
  link.content ='noindex';
  document.getElementsByTagName('head')[0].appendChild(link);
  import {mapGetters, mapState} from 'vuex'
  export default {
    name: 'app',
    data(){ return{} },
    components: {
      formWrap:    () => import('@/components/form/formWraplnd'),
      headBar:     () => import('@/components/section/headBar'),
      frstScreen:  () => import('@/components/section/frstScreen'),
      advantages:  () => import('@/components/section/advantages'),
      fast:        () => import('@/components/section/fast'),
      specAndDocs: () => import('@/components/section/specificationAndDocumentation'),
      contact:     () => import('@/components/section/contact'),
      footerLine:  () => import('@/components/section/footerLine'),
    },
    computed:{
      ...mapGetters(['isNotCC', 'doesNotRedirect']),
      ...mapState({ cookie: state => state.Cookie.cookie.Partner_Id, }),
    },
    mounted() {
      //alert('mounted')
      try {
        this.$store.dispatch('getDiealInfo');
        //тут смена полей адреса для мобильной версии, еще не работают нормально
        // this.$store.commit('selectAdressForm');
      } catch (e) {
        //alert('mounted' + JSON.stringify(e))
      }
      this.$store.dispatch('readCookie');
      // this.$myApi.sessionId();
      if (window.ym) {
        // eslint-disable-next-line no-undef
        ym(51632228, 'reachGoal', 'allEnter');
        // eslint-disable-next-line no-undef
        ym(51632228, 'reachGoal', 'admdChainEnter');
      }
      if(process.env.NODE_ENV == 'development'){
        // this.$store.dispatch('formRouting', 'srcContact');
        // this.$store.dispatch('setTest');
      }
      //загрузка данных по лиду из api партнера
      if (window.partner_id === 100021) {
        this.$myApi.SendRequest({
          action:'getLead',
          leadGuid:window.subid,
        }).then(res=>{ this.$store.dispatch('setRequestField',res) }).catch(res=>{ console.log(res); })
      }
    }
  }
</script>

<style>
.layoutBorder {width: 94.5vw;margin: 4vw auto;background: #FFFFFF;box-shadow: 0px 4px 30px rgba(0, 0, 0, 0.1);border-radius: 8px;}
.layoutHeader {border-bottom: 2px solid #DFE0E1;padding: 5vw 5vw 4.5vw;}
.layoutFooter {min-height: 6.6vw;border-top: 2px solid #DFE0E1;padding: 5vw 5vw 4.5vw;position: relative;}
.layoutFooter.btnIsset {padding: 5vw 5vw 10vw;}
.layoutBody {background: #F8FAFB;padding: 5vw 5vw 4.5vw;}
@media screen and (min-width: 760px) {
	.layoutBorder {width: auto;margin: 2vw auto;}
	.layoutHeader {padding: 2.4vw 2.4vw 2.2vw;}
	.layoutFooter {min-height: 1vw;padding: 2.4vw 2.4vw 2.5vw;}
	.layoutFooter.btnIsset {padding: 2.4vw 2.4vw 5vw;}
	.layoutBody {padding: 2.4vw 2.4vw 4.5vw;}
}
@media screen and (min-width: 1200px){
	.layoutBorder {margin: 10px auto;max-width: 1100px;}
	.layoutHeader {padding: 15px 20px;}
	.layoutFooter {min-height: 70px;padding: 15px 20px;}
	.layoutFooter.btnIsset {padding: 15px 20px;}
	.layoutBody {padding: 15px 20px;}
}
</style>
